import {
  InputOrderLineCompensation,
  InputOrderShippingFeeCompensation
} from "lib/types/generated/graphql-types"

export interface InputOrderLineCompensationWithAmount extends InputOrderLineCompensation {
  compensationAmount: number
  previouslyCompensatedAmount: number
}

export interface InputShippingFeeCompensationWithAmount extends InputOrderShippingFeeCompensation {
  compensationAmount: number
  previouslyCompensatedAmount: number
}

export interface AddReasonComponent {
  function: () => void
  loading: boolean
}

export enum AddressType {
  SHIPPING_ADDRESS,
  BILLING_ADDRESS
}

export enum ReasonType {
  PRE_DEFINED,
  CUSTOM_INPUT,
  SKIP
}
